import React from 'react';
import { Box, Grid, Button, TextField, Tooltip, FormControlLabel, Radio, RadioGroup, Paper, Modal, InputAdornment } from '@mui/material';

/**
 * Checks if a value for 'required' exists in the properties
 * object, and returns it if so.
 * 
 * Default to true otherwise
 * 
 * @param {any} props
 * @returns
 */
function isRequired(props) {
    if (Object.hasOwn(props, 'required')) {
        return props.required;
    }
    return true;
}

/**
 * Field for the Billing form
 * 
 * Defaults field to required unless overriden
 * 
 * @param {any} props
 * @returns
 */
function BillingField(props) {
    const state = props.state;
    const inputProps = Object.hasOwn(props, 'inputProps') ? props.inputProps : {};

    return (
        <Box m={.5}>
            <TextField
                required={isRequired(props)}
                sx={props.ts}
                id={props.id}
                label={props.label}
                variant="outlined"
                fullWidth
                value={props.state[`${props.id}`]}
                onChange={(e) => props.handleFieldChange(props.id, e.target.value)}
                onBlur={(e) => props.handleBlur(props.id, e.target.value)}
                helperText={state?.errors ? state.errors[`${props.id}`] : ""}
                error={state?.errors ? !!state.errors[`${props.id}`] : false}
                inputProps={inputProps}
            />
        </Box>
    );
}
function BillingInfo(props) {

    const state = props.state; // TODO: probably don't do this
    const handleFieldChange = props.handleFieldChange;
    const handleBlur = props.handleBlur;
    const ts = props.ts

    return (
        <>
        <b style={{marginLeft: '1vh', gap: '1rem'}}>Billing Information</b>
                <Grid container direction="row" sx={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', p: '1vh', maxHeight: '35vh', overflowY: 'auto' }}>
                                <Grid item sm={3}>
                                        <BillingField
                                            ts={ ts }
                                            id='firstName'
                                            label="First Name"
                                            handleFieldChange={handleFieldChange}
                                            handleBlur={handleBlur}
                                            state={ state }
                                        />
                                </Grid>
                                <Grid item sm={3}>
                                        <BillingField
                                            ts={ts}
                                            id='lastName'
                                            label="Last Name"
                                            handleFieldChange={handleFieldChange}
                                            handleBlur={handleBlur}
                                            state={state}
                                        />
                                </Grid>
                                <Grid item sm={3}>
                                        <BillingField
                                            required={false}
                                            ts={ts}
                                            id='email'
                                            label="Email"
                                            variant="outlined"
                                            handleFieldChange={handleFieldChange}
                                            handleBlur={handleBlur}
                                            state={state}
                                        />
                                </Grid>
                    <Grid item sm={9.25}>
                            <BillingField
                                ts={ts}
                                id='billingAddress'
                                label="Billing Address"
                                handleFieldChange={handleFieldChange}
                                handleBlur={handleBlur}
                                state={state}
                            />
                    </Grid>
                    <Grid item sm={3}>
                            <BillingField
                                ts={ts}
                                id='city'
                                label="City"
                                handleFieldChange={handleFieldChange}
                                handleBlur={handleBlur}
                                state={state}
                            />
                    </Grid>
                    <Grid item sm={3}>
                            <BillingField
                                ts={ts}
                                id='state'
                                label="State"
                                variant="outlined"
                                handleFieldChange={handleFieldChange}
                                handleBlur={handleBlur}
                                state={state}
                                inputProps={{ maxlength: "2" }}
                            />
                    </Grid>
                    <Grid item sm={3}>
                            <BillingField
                                ts={ts}
                                id='zipCode'
                                label="Zip Code"
                                handleFieldChange={handleFieldChange}
                                handleBlur={handleBlur}
                                state={state}
                                inputProps={{ maxLength: '10' }}
                            />
                    </Grid>
                </Grid>
</>    )

}

export default BillingInfo;